import apiClient from '../authentication/utils/core/axios';

/**
 * ContentReviewAPI -- the user-facing + admin-facing dispute/appeal system
 * closing 2 related compliance gaps in one feature: GDPR Art 22 (no way to
 * contest an automated prediction outcome) and DSA Art 14(1)/17 (no reason
 * or dispute path when content is moderated).
 */
const ContentReviewAPI = {
  submitReview: async ({ target_type, target_id, reason }) => {
    const res = await apiClient.post('/reviews', { target_type, target_id, reason });
    return res.data;
  },

  fetchMine: async () => {
    const res = await apiClient.get('/reviews/mine');
    return res.data;
  },

  fetchAdminQueue: async (status) => {
    const query = status ? `?status=${status}` : '';
    const res = await apiClient.get(`/admin/reviews${query}`);
    return res.data;
  },

  decide: async (reviewId, { decision, admin_reason }) => {
    const res = await apiClient.patch(`/admin/reviews/${reviewId}/decision`, { decision, admin_reason });
    return res.data;
  },
};

export default ContentReviewAPI;
